export default {
	inUse: {
		// A refused remove: the places that still use what it would take away, each a link to fix.
		heading: "Still used in",
		fixFirst: "Change or remove these first, then try again.",
		titles: {
			attribute: "This attribute can't be removed",
			processEntry: "This dataobject can't be removed from the process",
		},
		groups: {
			attributes: "Attributes",
			types: "Types",
			processes: "Processes",
		},
		// What the place does with it, said after the place. Keyed by the generator's stable `kind`.
		kinds: {
			writer: "writes it",
			listener: "listens to it",
			variable: "reads it in a field",
			condition: "condition",
			questionText: "in a question's text",
			suggestion: "suggests for it",
			graphlyFill: "Graphly field",
			attributeType: "has this type",
			annotation: "type annotation",
			unionMember: "union member",
			selectDatatype: "select options",
			axiomLiteral: "axiom",
			operationTemplate: "creates a dataobject from it",
		},
	},
};
